module.exports = __webpack_public_path__ + "static/media/2122-service-2-6-min.7ff24eaf.jpg";